export function formatUserLocalDate(
	value: string | Date | null | undefined,
	fallback = '—'
): string {
	if (!value) return fallback;

	const date = normalizeDate(value);
	if (!date) return typeof value === 'string' ? value : fallback;

	return new Intl.DateTimeFormat(undefined).format(date);
}

function normalizeDate(value: string | Date): Date | null {
	if (value instanceof Date) {
		return Number.isFinite(value.getTime()) ? value : null;
	}

	const trimmed = value.trim();
	if (!trimmed) return null;

	// Keep yyyy-mm-dd dates in local time to avoid UTC day shifts.
	const localDateMatch = /^(\d{4})-(\d{2})-(\d{2})$/.exec(trimmed);
	if (localDateMatch) {
		const [, y, m, d] = localDateMatch;
		const localDate = new Date(Number(y), Number(m) - 1, Number(d));
		return Number.isFinite(localDate.getTime()) ? localDate : null;
	}

	const parsed = new Date(trimmed);
	return Number.isFinite(parsed.getTime()) ? parsed : null;
}
